import { Component, Input, OnInit } from "@angular/core";
import { IDriver } from "@app/interfaces/IDriver";
import { IVideoEntry } from "@app/main/components/videos/models/IVideoEntry";
import { DriverAssignmentService } from "@app/services/driverAssignment.service";

@Component({
    selector: 'video-driver-assignment',
    template: require('./video-driver-assignment.component.html')
})
export class VideoDriverAssignmentComponent implements OnInit {

    @Input() videoEntry: IVideoEntry;

    driver: IDriver;
    loading: boolean;
    constructor(private readonly driverAssignmentService: DriverAssignmentService) { }

    ngOnInit(): void {
        this.getDriverAssignment();
    }

    //--

    private getDriverAssignment(): void {
        if (this.videoEntry?.driver) {
            this.driver = this.videoEntry.driver;
            return;
        }

        this.loading = true;

        this.driverAssignmentService.getDriverAssignmentForTime(this.videoEntry.VehicleId, this.videoEntry.VideoStartTime).then(
            driver => {
                this.driver = driver;                
            }
        ).finally(() => {
            this.loading = false;
        })
    }
}
